/* Deluxe PDP (Liquid) — behaviour for sections/rr-deluxe-pdp.liquid.
   Vanilla JS, no jQuery needed except for the add-to-cart hand-off to the
   theme's own cart drawer (theme.addToCartOk -> theme.RightDrawer.open()).
   All clicks are delegated at document level so the section survives the
   theme editor re-rendering it. */
(function () {
  "use strict";

  function closest(el, sel) {
    while (el && el.nodeType === 1) { if (el.matches(sel)) return el; el = el.parentElement; }
    return null;
  }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  /* ------------------------------------------------------------------
     Gallery: native scroll-snap track, arrows / thumbs / dots follow it
     ------------------------------------------------------------------ */
  function galleryIndex(track) {
    var w = track.clientWidth || 1;
    return Math.round(track.scrollLeft / w);
  }
  function galleryGo(root, i) {
    var track = root.querySelector(".rd-gallery__track");
    var n = track.children.length;
    i = Math.max(0, Math.min(n - 1, i));
    track.scrollTo({ left: i * track.clientWidth, behavior: "smooth" });
  }
  function gallerySync(root) {
    var track = root.querySelector(".rd-gallery__track");
    if (!track) return;
    var n = track.children.length;
    var i = galleryIndex(track);
    if (root.getAttribute("data-rd-index") === String(i)) return;
    root.setAttribute("data-rd-index", String(i));
    each(root.querySelectorAll("[data-rd-goto]"), function (b) {
      b.setAttribute("aria-current", String(parseInt(b.getAttribute("data-rd-goto"), 10) === i));
    });
    var prev = root.querySelector(".rd-gallery__arrow--prev");
    var next = root.querySelector(".rd-gallery__arrow--next");
    if (prev) prev.disabled = i <= 0;
    if (next) next.disabled = i >= n - 1;
    var status = root.querySelector(".rd-gallery__status");
    if (status) status.textContent = "Slide " + (i + 1) + " of " + n;
    /* pause any playing gallery video that scrolled away */
    each(track.querySelectorAll("video"), function (v) { if (!v.paused) v.pause(); });
  }
  function initGallery(root) {
    if (root.getAttribute("data-rd-init") === "1") return;
    root.setAttribute("data-rd-init", "1");
    var track = root.querySelector(".rd-gallery__track");
    if (!track) return;
    var raf = null;
    track.addEventListener("scroll", function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; gallerySync(root); });
    }, { passive: true });
    track.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") { e.preventDefault(); galleryGo(root, galleryIndex(track) + 1); }
      if (e.key === "ArrowLeft") { e.preventDefault(); galleryGo(root, galleryIndex(track) - 1); }
    });
    gallerySync(root);
  }

  /* ------------------------------------------------------------------
     UGC strip (mobile slider arrows)
     ------------------------------------------------------------------ */
  function ugcSync(wrap) {
    var track = wrap.querySelector(".rd-ugc__track");
    if (!track) return;
    var prev = wrap.querySelector(".rd-ugc__arrow--prev");
    var next = wrap.querySelector(".rd-ugc__arrow--next");
    var max = track.scrollWidth - track.clientWidth - 4;
    if (prev) prev.disabled = track.scrollLeft <= 4;
    if (next) next.disabled = track.scrollLeft >= max;
  }
  function initUgc(wrap) {
    if (wrap.getAttribute("data-rd-init") === "1") return;
    wrap.setAttribute("data-rd-init", "1");
    var track = wrap.querySelector(".rd-ugc__track");
    if (!track) return;
    var raf = null;
    track.addEventListener("scroll", function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; ugcSync(wrap); });
    }, { passive: true });
    ugcSync(wrap);
  }
  function ugcStep(wrap, dir) {
    var track = wrap.querySelector(".rd-ugc__track");
    var tile = track && track.querySelector(".rd-ugc__tile--mobile, .rd-ugc__tile");
    var step = tile ? tile.getBoundingClientRect().width + 12 : track.clientWidth * 0.8;
    track.scrollBy({ left: dir * step, behavior: "smooth" });
  }

  /* ------------------------------------------------------------------
     Click-to-play: <video> is created only on click (preload=none until
     then). Poster <img> stays lazy. One video plays at a time.
     ------------------------------------------------------------------ */
  function pauseOthers(except) {
    each(document.querySelectorAll(".rd-pdp video"), function (v) { if (v !== except && !v.paused) v.pause(); });
  }
  function playMp4(btn) {
    var src = btn.getAttribute("data-rd-mp4");
    if (!src) return;
    var box = btn.parentElement;
    var img = btn.querySelector("img");
    var v = document.createElement("video");
    v.preload = "none";
    v.controls = true;
    v.playsInline = true;
    v.setAttribute("playsinline", "");
    v.setAttribute("webkit-playsinline", "");
    if (img && (img.currentSrc || img.src)) v.poster = img.currentSrc || img.src;
    v.src = src;
    v.addEventListener("play", function () { pauseOthers(v); });
    box.replaceChild(v, btn);
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function playVimeo(btn) {
    var id = btn.getAttribute("data-rd-vimeo");
    if (!id) return;
    var box = btn.parentElement;
    var f = document.createElement("iframe");
    f.src = "https://player.vimeo.com/video/" + encodeURIComponent(id) + "?autoplay=1&title=0&byline=0&portrait=0&dnt=1";
    f.allow = "autoplay; fullscreen; picture-in-picture";
    f.setAttribute("allowfullscreen", "");
    f.title = btn.getAttribute("aria-label") || "Video";
    pauseOthers(null);
    box.replaceChild(f, btn);
  }

  /* ------------------------------------------------------------------
     Accordions (product tabs + FAQ) and audience tabs
     ------------------------------------------------------------------ */
  function toggleAcc(btn) {
    var panel = document.getElementById(btn.getAttribute("aria-controls"));
    var open = btn.getAttribute("aria-expanded") === "true";
    btn.setAttribute("aria-expanded", String(!open));
    if (panel) { if (open) panel.setAttribute("hidden", ""); else panel.removeAttribute("hidden"); }
  }
  function selectTab(tab) {
    var list = closest(tab, "[role=tablist]");
    if (!list) return;
    each(list.querySelectorAll("[role=tab]"), function (t) {
      var on = t === tab;
      t.setAttribute("aria-selected", String(on));
      t.tabIndex = on ? 0 : -1;
      var p = document.getElementById(t.getAttribute("aria-controls"));
      if (p) { if (on) p.removeAttribute("hidden"); else p.setAttribute("hidden", ""); }
    });
  }

  /* ------------------------------------------------------------------
     Colour swatches are real links to the paired product. While previewing
     (or arriving from an ad) carry the query string over, minus `variant`
     (a variant id never belongs to the other product).
     ------------------------------------------------------------------ */
  function carryQuery() {
    var q = window.location.search;
    if (!q || q.length < 2) return;
    var keep = q.slice(1).split("&").filter(function (kv) { return kv && kv.split("=")[0] !== "variant"; }).join("&");
    if (!keep) return;
    each(document.querySelectorAll(".rd-pdp a[data-rd-swatch]"), function (a) {
      if (a.getAttribute("data-rd-carried") === "1") return;
      var href = a.getAttribute("href");
      a.setAttribute("href", href + (href.indexOf("?") === -1 ? "?" : "&") + keep);
      a.setAttribute("data-rd-carried", "1");
    });
  }

  /* ------------------------------------------------------------------
     Tier selector: the radios ARE the form's `id` field, so the form
     always submits the checked tier variant. Here we only mirror the
     checked tier into the price block and the sticky bar.
     ------------------------------------------------------------------ */
  function tierSync(root) {
    var input = root.querySelector(".rd-tier__input:checked");
    if (!input) return;
    var price = input.getAttribute("data-price") || "";
    var was = input.getAttribute("data-was") || "";
    var save = input.getAttribute("data-save") || "";
    var set = function (sel, txt) { var el = root.querySelector(sel); if (el) el.textContent = txt; };
    var show = function (sel, on) { var el = root.querySelector(sel); if (el) { if (on) el.removeAttribute("hidden"); else el.setAttribute("hidden", ""); } };
    set("[data-rd-now]", price);
    set("[data-rd-was-amt]", was);
    set("[data-rd-save]", save);
    show("[data-rd-was]", !!was);
    show("[data-rd-save]", !!save);
    set("[data-rd-sticky-now]", price);
    /* FIX F: the express checkout (Shop Pay) button reads the FIRST [name=id] field of the form, so with JS the radios are
       renamed and a hidden id field mirrors the checked tier (without JS the radios keep name="id" and post normally). */
    var hid = root.querySelector("input[data-rd-id]");
    if (hid && hid.value !== input.value) { hid.value = input.value; hid.dispatchEvent(new Event("change", { bubbles: true })); }
    var sw = root.querySelector("[data-rd-sticky-was]");
    if (sw) { sw.textContent = was; if (was) sw.removeAttribute("hidden"); else sw.setAttribute("hidden", ""); }
    tierImage(root, input);
  }
  /* Gallery slide 1 (and its desktop thumb) shows the chosen tier's pack shot: 1 rocker, 2 or 3 (B-17).
     Tier 1 restores the page's own first image. */
  function tierImage(root, input) {
    var img = root.querySelector(".rd-gallery__slide img");
    if (!img) return;
    var thumb = root.querySelector('.rd-gallery__thumb[data-rd-goto="0"] img');
    if (!img.hasAttribute("data-rd-orig")) {
      img.setAttribute("data-rd-orig", "1");
      img.setAttribute("data-rd-orig-src", img.getAttribute("src") || "");
      img.setAttribute("data-rd-orig-srcset", img.getAttribute("srcset") || "");
      img.setAttribute("data-rd-orig-alt", img.getAttribute("alt") || "");
      if (thumb) { thumb.setAttribute("data-rd-orig-src", thumb.getAttribute("src") || ""); thumb.setAttribute("data-rd-orig-srcset", thumb.getAttribute("srcset") || ""); }
    }
    var tier = input.getAttribute("data-rd-tier");
    var src = input.getAttribute("data-img");
    var useOrig = tier === "1" || !src;
    var want = useOrig ? img.getAttribute("data-rd-orig-src") : src;
    if (img.getAttribute("src") === want) return;
    if (useOrig) {
      img.setAttribute("srcset", img.getAttribute("data-rd-orig-srcset"));
      img.setAttribute("src", want);
      img.setAttribute("alt", img.getAttribute("data-rd-orig-alt"));
    } else {
      img.setAttribute("srcset", input.getAttribute("data-srcset") || "");
      img.setAttribute("src", src);
      img.setAttribute("alt", input.getAttribute("data-alt") || img.getAttribute("data-rd-orig-alt"));
    }
    if (thumb) {
      var ts = useOrig ? thumb.getAttribute("data-rd-orig-src") : input.getAttribute("data-thumb");
      if (ts) { thumb.removeAttribute("srcset"); thumb.setAttribute("src", ts); if (useOrig && thumb.getAttribute("data-rd-orig-srcset")) thumb.setAttribute("srcset", thumb.getAttribute("data-rd-orig-srcset")); }
    }
  }
  function initTiers(root) {
    var inputs = root.querySelectorAll(".rd-tier__input");
    if (!inputs.length) return;
    var form = inputs[0].form;
    if (form && !form.querySelector("input[data-rd-id]")) {
      var hid = document.createElement("input");
      hid.type = "hidden"; hid.name = "id"; hid.setAttribute("data-rd-id", "");
      form.insertBefore(hid, form.firstChild);
      each(inputs, function (i) { i.name = "rd-tier"; });
    }
    /* a tier chosen on the twin colour page (swatch click) is carried over once */
    var want = null;
    try { want = window.sessionStorage.getItem("rdTier"); window.sessionStorage.removeItem("rdTier"); } catch (e) { want = null; }
    var checked = root.querySelector(".rd-tier__input:checked");
    if (want) {
      var w = root.querySelector('.rd-tier__input[data-rd-tier="' + want + '"]');
      if (w && !w.disabled) { w.checked = true; checked = w; }
    }
    if (!checked || checked.disabled) {
      for (var i = 0; i < inputs.length; i++) { if (!inputs[i].disabled) { inputs[i].checked = true; break; } }
    }
    tierSync(root);
  }

  /* ------------------------------------------------------------------
     Sticky add to cart (<= 768px, CSS hides it above that). Visible only
     while the main ATC button is above the viewport.
     ------------------------------------------------------------------ */
  function initSticky(root) {
    var bar = root.querySelector("[data-rd-sticky]");
    var atc = root.querySelector("[data-rd-atc]");
    if (!bar || !atc || bar.getAttribute("data-rd-init") === "1") return;
    bar.setAttribute("data-rd-init", "1");
    /* rAF-throttled passive scroll check (an IntersectionObserver misses jumps
       that skip over the button, e.g. a fast fling back to the top). */
    var raf = null, state = null;
    function check() {
      raf = null;
      var on = atc.getBoundingClientRect().bottom < 0;
      if (on === state) return;
      state = on;
      bar.classList.toggle("is-on", on);
      if (on) bar.removeAttribute("inert"); else bar.setAttribute("inert", "");
    }
    window.addEventListener("scroll", function () { if (!raf) raf = requestAnimationFrame(check); }, { passive: true });
    window.addEventListener("resize", function () { if (!raf) raf = requestAnimationFrame(check); }, { passive: true });
    check();
  }

  /* ------------------------------------------------------------------
     Add to cart: same request the theme's product form makes (jQuery POST
     /cart/add.js with the serialized {% form 'product' %}), then the
     theme's own success handler, which refreshes the inline cart and
     opens the cart drawer. Fallback without theme.js: fetch + /cart.
     ------------------------------------------------------------------ */
  function onSubmit(form, e) {
    e.preventDefault();
    var btn = form.querySelector("[type=submit]");
    if (form.getAttribute("data-rd-form") === "main" && !form.querySelector("[name=id]:checked, input[type=hidden][name=id]")) return;
    var label = btn ? btn.querySelector(".rd-atc-label") : null;
    var err = form.querySelector(".rd-form__error");
    if (!btn || btn.disabled) return;
    var idle = label ? label.textContent : "";
    btn.disabled = true;
    if (label) label.textContent = btn.getAttribute("data-rd-busy") || "Adding…";
    if (err) err.setAttribute("hidden", "");
    function done() { btn.disabled = false; if (label) label.textContent = idle; }
    function fail(msg) {
      done();
      if (err) { err.textContent = msg || "Sorry, something went wrong. Please try again."; err.removeAttribute("hidden"); }
    }
    var $ = window.jQuery;
    if ($ && window.theme && typeof window.theme.addToCartOk === "function") {
      $.ajax({ type: "POST", url: "/cart/add.js", dataType: "json", data: $(form).serialize() })
        .done(function (item) {
          done();
          try { window.theme.addToCartOk(item); }
          catch (x) { window.location.href = "/cart"; }
        })
        .fail(function (xhr) {
          var d = xhr && xhr.responseJSON;
          fail(d && (d.description || d.message));
        });
      return;
    }
    fetch("/cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) { if (res.ok) window.location.href = "/cart"; else fail(res.j && (res.j.description || res.j.message)); })
      .catch(function () { fail(); });
  }

  /* ------------------------------------------------------------------ */
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!closest(t, ".rd-pdp")) return;

    var b = closest(t, "[data-rd-mp4]");
    if (b) { e.preventDefault(); playMp4(b); return; }
    b = closest(t, "[data-rd-vimeo]");
    if (b) { e.preventDefault(); playVimeo(b); return; }

    if (closest(t, ".rd-rating")) loadOkendo();

    b = closest(t, ".rd-acc__btn");
    if (b) { toggleAcc(b); return; }

    b = closest(t, "[role=tab]");
    if (b) { selectTab(b); return; }

    b = closest(t, "[data-rd-sticky-atc]");
    if (b) {
      var mf = document.getElementById(b.getAttribute("aria-controls"));
      if (mf) { if (mf.requestSubmit) mf.requestSubmit(); else { var sb = mf.querySelector("[type=submit]"); if (sb) sb.click(); } }
      return;
    }
    b = closest(t, "a[data-rd-swatch]");
    if (b) {
      var ck = document.querySelector(".rd-pdp .rd-tier__input:checked");
      try { if (ck) window.sessionStorage.setItem("rdTier", ck.getAttribute("data-rd-tier")); } catch (x) {}
      return;
    }

    b = closest(t, "[data-rd-goto]");
    if (b) { galleryGo(closest(b, ".rd-gallery"), parseInt(b.getAttribute("data-rd-goto"), 10)); return; }
    b = closest(t, ".rd-gallery__arrow");
    if (b) {
      var g = closest(b, ".rd-gallery");
      galleryGo(g, galleryIndex(g.querySelector(".rd-gallery__track")) + (b.classList.contains("rd-gallery__arrow--prev") ? -1 : 1));
      return;
    }
    b = closest(t, ".rd-ugc__arrow");
    if (b) { ugcStep(closest(b, ".rd-ugc__wrap"), b.classList.contains("rd-ugc__arrow--prev") ? -1 : 1); return; }
  });

  document.addEventListener("change", function (e) {
    var inp = closest(e.target, ".rd-pdp .rd-tier__input");
    if (!inp) return;
    var root = closest(inp, ".rd-pdp");
    tierSync(root);
    /* bring slide 1 (the pack shot) back into view inside the gallery; the page itself does not scroll */
    var g = root.querySelector(".rd-gallery");
    var tr = g && g.querySelector(".rd-gallery__track");
    if (tr && galleryIndex(tr) !== 0) galleryGo(g, 0);
  });

  document.addEventListener("keydown", function (e) {
    var tab = closest(e.target, ".rd-pdp [role=tab]");
    if (!tab || (e.key !== "ArrowRight" && e.key !== "ArrowLeft")) return;
    var tabs = Array.prototype.slice.call(closest(tab, "[role=tablist]").querySelectorAll("[role=tab]"));
    var i = tabs.indexOf(tab) + (e.key === "ArrowRight" ? 1 : -1);
    var nxt = tabs[(i + tabs.length) % tabs.length];
    selectTab(nxt); nxt.focus(); e.preventDefault();
  });

  document.addEventListener("submit", function (e) {
    var form = closest(e.target, ".rd-pdp form[data-rd-form]");
    if (form) onSubmit(form, e);
  }, true);

  /* ------------------------------------------------------------------
     Okendo Widget Plus: load the script only when the reviews block is
     near (1200px) or the star summary is clicked.
     ------------------------------------------------------------------ */
  function loadOkendo() {
    var host = document.querySelector(".rd-pdp [data-rd-okendo]");
    if (!host || window.__rdOkendoLoaded) return;
    window.__rdOkendoLoaded = true;
    var s = document.createElement("script");
    s.src = host.getAttribute("data-rd-okendo");
    s.defer = true;
    document.head.appendChild(s);
  }
  function initOkendo() {
    var host = document.querySelector(".rd-pdp [data-rd-okendo]");
    if (!host || window.__rdOkendoLoaded) return;
    if (!("IntersectionObserver" in window)) { loadOkendo(); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (en) { return en.isIntersecting; })) { io.disconnect(); loadOkendo(); }
    }, { rootMargin: "1200px 0px 1200px 0px" });
    io.observe(host);
  }

  function init() {
    each(document.querySelectorAll(".rd-pdp .rd-gallery"), initGallery);
    each(document.querySelectorAll(".rd-pdp .rd-ugc__wrap"), initUgc);
    each(document.querySelectorAll(".rd-pdp"), function (r) { initTiers(r); initSticky(r); });
    carryQuery();
    initOkendo();
  }
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
  var rt = null;
  window.addEventListener("resize", function () {
    clearTimeout(rt);
    rt = setTimeout(function () {
      each(document.querySelectorAll(".rd-pdp .rd-gallery"), function (g) { g.removeAttribute("data-rd-index"); gallerySync(g); });
      each(document.querySelectorAll(".rd-pdp .rd-ugc__wrap"), ugcSync);
    }, 150);
  });
})();
